export default __webpack_public_path__ + "static/media/8.14.bc18ffc0.mp3";